<template>
    <div class="application-page">
        <div class="d-flex align-items-center justify-content-between">
            <div class="me-2">
                <RouterLink class="btn btn-ghost btn-back" to="/catalog">
                    <LeftIcon class="icon" />
                </RouterLink>
            </div>
            <div class="flex-grow-1 page-title">
                Заявка на лизинг
            </div>
            <div class="ms-2" style="width: 36px"></div>
        </div>

        <div size="2" class="mb-4 hr"></div>

        <!-- та же форма, что в окне «Произвольная заявка» и на главной:
             письмо персональному менеджеру со всеми данными и файлом КП -->
        <div class="row justify-content-center application-form-row">
            <div class="col-md-9 col-lg-7 col-xl-6">
                <ApplicationForm kind="own" />
            </div>
        </div>
    </div>
</template>


<script>
import LeftIcon from "@/assets/svg/left.vue";
import ApplicationForm from "@/component/application/ApplicationForm.vue";

export default {
    name: 'catalog-application',
    components: { LeftIcon, ApplicationForm },
    created() {
        document.title = "Заявка на лизинг - STONE-XXI"
    }
}
</script>

<style scoped>
/* 110px = шапка (70px) + нижний отступ content-main (40px) */
.application-page {
    min-height: calc(100vh - 110px);
    display: flex;
    flex-direction: column;
}

.application-form-row {
    margin-top: auto !important;
    margin-bottom: auto !important;
    padding-bottom: 40px;
}
</style>
